<template>
  <div class="c-overview-summary component">
    <span class="text--gray">Dokonano następującego wyboru</span>
    <br />
    <div class="mb--1 mt--1" v-if="getSelectedDealer && getSelectedDealer.name">
      <img src="@/assets/localizations.jpg" alt="Localization" class="c-overview-summary__icon" />
      <h3 class="c-overview-summary__dealerName">{{ getSelectedDealer.name }}</h3>
      Doradca serwisowy: {{ lead.termData.advisor_name }}
      <span v-html="lead.termData.user_phone
      ? '<br>tel:' + lead.termData.user_phone
      : ''
      "></span>
      <span v-html="lead.termData.user_email
      ? '<br>' + lead.termData.user_email + '<br>'
      : ''
      "></span>
      <br />
    </div>
    <div class="mb--5 mt--1">
      <span>Zaplanowane przyjęcie w dniu
        {{ getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.date)] }}
        {{ lead.date }}, o godzinie, {{ lead.hour }}.</span>
      <br />
      <span>Zaplanowane zakończenie naprawy w dniu
        {{
          getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(lead.repair.date)]
        }}, {{ lead.repair.date }} o godz. {{ getEndDate.getHours() }}:{{
          getEndDate.getMinutes().toString().padStart(2, '0')
        }}</span>
    </div>
    <div class="mb--5 mt--1" v-if="lead.replacement_car_id != null">
      Mobilność:
      {{
      [...getReplacementCars]
        .filter((e) => (e.id == lead.replacement_car_id ? e.model : false))
        .map((e) => e.brand + " " + e.model)[0]
    }}
    </div>
    <span class="text--gray">Usługi do wykonania:</span>
    <div class="flex-col--5 mt--1 mb--2">
      <p>{{ lead.services_name.join(', ') }}</p>
    </div>
    <div class="mb--5 mt--1">
      <span>
        Po potwierdzeniu wizyty – dostaniesz unikatowy link ze statusem swojej naprawy.
      </span>
    </div>


  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { getDate, getDateWithBufor } from "../../helpers/date.js";
import lead from "../../mixins/lead.js";
export default {
  mixins: [lead],
  computed: {
    ...mapGetters({
      getDealers: "definitions/getDealers",
      getModels: "definitions/getModels",
      getAvailableTerms: "definitions/getAvailableTerms",
      getDetepickerConfig: "definitions/getDetepickerConfig",
      getReplacementCars: "definitions/getReplacementCars",
      getServices: "definitions/getServices",
    }),
    getSelectedDealer() {
      return this.getDealers.find((e) => e.id == this.lead.dealer_id);
    },
    getEndDate() {
      return getDateWithBufor(getDate(this.lead.repair), 120);
    },
  },
};
</script>
<style lang="scss">
.c-overview-summary {
  font-size: 1.25rem;

  &__icon {
    width: 24px;
    float: left;
    margin-right: 0.25rem;
  }

  &__dealerName {}

  &__service {
    font-size: 1rem;
  }
}
</style>
